module.exports = __webpack_public_path__ + "img/product-penjaminan-kredit-umum.8bcf6e73.jpeg";